'use strict'

import ApiClient from './ApiClient'

export default class AuthRepository {
  /**
   * ログイン
   * @param data ログインデータ
   * @returns {*}
   */
  login (data) {
    return ApiClient().post(`/login`, data)
  }

  /**
   * ログアウト
   * @returns {*}
   */
  logout () {
    return ApiClient().post(`/logout`)
  }

  /**
   * パスワードを更新します。
   * @param params 更新内容
   * @returns {*}
   */
  changePass (params) {
    return ApiClient().put(`/password`, params)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/AuthRepository.js